import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/shared/components/ui/button";
import { cn } from '@/shared/utils/cn';

/**
 * ThemeToggle Component
 * 
 * Premium theme switcher with smooth animations and glassmorphism.
 * Allows users to toggle between light and dark modes.
 * 
 * Features:
 * - Smooth transitions
 * - Active state indicators
 * - Glassmorphism styling
 * - Pulse animation on active theme
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="h-9 w-9 rounded-[10px] transition-all duration-200"
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <Sun className={cn(
        "h-4 w-4 transition-all duration-200",
        isDark ? "rotate-90 scale-0 absolute" : "rotate-0 scale-100"
      )} />
      <Moon className={cn(
        "h-4 w-4 transition-all duration-200",
        isDark ? "rotate-0 scale-100" : "-rotate-90 scale-0 absolute"
      )} />
    </Button>
  );
}
